<script setup lang="ts">
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'

defineProps<{
  data: PressListRecord
}>()

const modules = [Parallax, A11y]

const { isDesktop } = useDevice()
</script>

<template>
  <LazyPressBlock v-if="data.blocks.length === 1" :data="data.blocks[0] as PressRecord" />
  <div v-else data-lenis-prevent>
    <Swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      :loop="true"
      :grab-cursor="true"
      :speed="1100"
      :auto-height="true"
      :parallax="isDesktop"
      class="!relative mb-12 lg:mb-0"
    >
      <SwiperSlide v-for="(item, idx) in data.blocks" :key="idx">
        <LazyPressBlock :data="item as PressRecord" />
      </SwiperSlide>
      <SwiperNav
        class="absolute bottom-0 left-1/2 top-auto z-10 mx-auto w-full max-w-2xl -translate-x-1/2 px-4 lg:bottom-32"
      />
    </Swiper>
  </div>
</template>
